export default {
  title: {
    id: 'rm_mine-my-phone-story01_name',
    defaultMessage:
      'Fast Tech’s need for gold is making Ghana’s rivers run brown',
  },
  excerpt: {
    id: 'rm_mine-my-phone-story01_excerpt',
    defaultMessage:
      'Today, gold remains one of the strongest pillars of the Ghanaian economy. It’s not only shaping the nation’s fortune, but it’s also powering the world’s consumer technology industry. Here, Ghanaian environmental journalist Albert Oppong-Ansah explores the devastating impact of this billion-dollar mining industry.',
  },
  regionName: {
    id: 'rm_mine-my-phone-story01_region_name',
    defaultMessage: 'Wassa Akropong',
  },
  s1P1: {
    id: 'rm_mine-my-phone-story01_s1_p1',
    defaultMessage:
      'Descending into a wide, excavator-dug pit in the belly of Ghana’s red earth was not the first choice for 45-year-old Ofa Yaw Adu. But it is the harsh reality he has come to accept. A cocoa, cassava, and plantain farmer by trade, Yaw lost his livelihood five years ago when the land he had leased for farming was sold by the landlord to gold miners.',
  },
  s1P2: {
    id: 'rm_mine-my-phone-story01_s1_p2',
    defaultMessage:
      'Today his daily routine involves carting excavated and crushed ore across mining sites in Wassa Akropong, the capital of Wassa Amenfi East Municipality in the Western Region, 303 kilometers from Accra, Ghana’s national capital. He typically supports the washing and separation process, where crushed material is mixed with water and run over sluice boards to separate heavier gold particles from waste. These are procedures crucial to Ghana’s gold extraction industry, which was worth USD 31.1 billion in 2025, making it the country’s biggest export revenue stream.',
  },
  s1P3: {
    id: 'rm_mine-my-phone-story01_s1_p3',
    defaultMessage:
      '“This is what puts food on the table for my family and pays bills like school fees and education materials,” Yaw Adu explained soberly. Towering open pits, left uncovered after digging operations, rumbled behind him. A few kilometers away, 40-year-old Kweku Tandoh operated a changfa machine alongside foreign nationals. Together, they blocked flowing rivers, dredged riverbeds for alluvial gold, washed it with mercury, and then discharged the contaminated water back into the river. It’s the reason the local waters are running brown.',
  },
  s1P4: {
    id: 'rm_mine-my-phone-story01_s1_p4',
    defaultMessage:
      'Yaw and Kweku represent millions across Ghana’s artisanal and small-scale mining (ASM) sector. It is made up of schoolchildren as young as 10 years old, as well as women and migrants from other countries (including Burkina Faso, Nigeria, Ivory Coast, India, China, and Niger). They are all drawn in by the promise of generating quick income in a country where formal employment remains elusive.',
  },
  s2Title: {
    id: 'rm_mine-my-phone-story01_s2_title',
    defaultMessage: 'Ghana’s lifeblood and global connection',
  },
  s2P1: {
    id: 'rm_mine-my-phone-story01_s2_p1',
    defaultMessage:
      'Ghana’s relationship with gold runs deep. The country’s former colonial name, the Gold Coast, reflected the abundance of this raw material that attracted European slave traders long before independence. Today, gold remains one of the strongest pillars of the Ghanaian economy, shaping the fortunes of the nation and millions of its people.',
  },
  s3P1: {
    id: 'rm_mine-my-phone-story01_s3_p1',
    defaultMessage:
      'Yet Ghana’s gold is not just powering its own economy. It’s also powering the world’s technology industry. Every time someone unlocks a smartphone, opens a laptop, or streams a video, a tiny quantity of gold (less than 13 mg per device) is at work inside. This coats the connectors, contacts, and circuit board components that ensure reliable electrical signals. Gold is prized for this role because, unlike copper or silver, it does not corrode over time.',
  },
  s3P2: {
    id: 'rm_mine-my-phone-story01_s3_p2',
    defaultMessage:
      '“Gold is prized not only for jewelry and investment, but also because it is one of the world’s best electrical conductors. Tiny quantities are found in smartphones, computers, medical equipment, satellites, and countless other electronic devices,” explained Mr. Samuel Boateng, a technology consultant based in the United States.',
  },
  s4Title: {
    id: 'rm_mine-my-phone-story01_s4_title',
    defaultMessage: 'The numbers behind the Gold',
  },
  s4P1: {
    id: 'rm_mine-my-phone-story01_s4_p1',
    defaultMessage:
      'The scale of Ghana’s small-scale gold output is staggering. Thomas Nyarko Ampem, Deputy Minister of Finance, told Ghana’s Parliament that - between January 2025 and May 2026 - the small-scale mining sector alone [produced 135,221 tonnes of gold.](https://www.facebook.com/watch/?v=993089873318061) Meanwhile, the Ghana Gold Board (GoldBod) purchased a total of 135,843 tonnes across the same period, with the overwhelming bulk (135,221 tonnes) sourced from the ASM (the unregulated small-scale mining sector), and the remainder from large-scale mining companies.',
  },
  s4P2: {
    id: 'rm_mine-my-phone-story01_s4_p2',
    defaultMessage:
      '“In 2025, GoldBod cumulatively purchased, aggregated, and exported ASM gold totalling 104 tonnes, which generated in excess of $10 billion for the country,” the Deputy Minister said at the time. The macroeconomic impact has been equally significant. Ghana recorded total export earnings of $6.2 billion in January and February 2026 alone, a sharp jump from the $4.2 billion recorded over the same period in 2024 (according to the Bank of Ghana’s Summary of [Economic and Financial Data](https://www.bog.gov.gh/monetary-policy/summary-of-economic-and-financial-data/)).',
  },
  s4P3: {
    id: 'rm_mine-my-phone-story01_s4_p3',
    defaultMessage:
      '“Gold revenues have helped stabilize the Ghanaian cedi against major currencies, moderating fuel prices, transport fares, and food costs, providing welcome relief to millions of Ghanaians in urban and rural areas alike,” said Dr. Emmanuel Steve Asare Manteaw, Co-Chair of the Ghana Extractive Industries Transparency Initiative (GHEITI), under the Ministry of Finance.',
  },
  s5P1: {
    id: 'rm_mine-my-phone-story01_s5_p1',
    defaultMessage:
      'However, there’s also a darker side to the industry. Nearly a quarter of Ghana’s domestic revenue comes from the mining sector, which also provides large-scale employment and shores up foreign exchange reserves. Many gold workers and community members are exposed to heavy metals like mercury and cyanide. A recent [study revealed](https://www.nature.com/articles/s41598-025-17149-0#citeas) that crops such as cucumbers produced at abandoned small-scale mining sites contained dangerous levels of toxic metals (including mercury, cadmium, arsenic, and lead). These are the same chemicals used or released during gold mining.',
  },
  s6Title: {
    id: 'rm_mine-my-phone-story01_s6_title',
    defaultMessage: 'The hidden cost of the global gold rush',
  },
  s6P1: {
    id: 'rm_mine-my-phone-story01_s6_p1',
    defaultMessage:
      'Behind the remarkable output figures lies another Ghana, a country where forests have vanished; farmland has become wasteland; and communities increasingly [fear the water flowing](https://www.parliament.gh/floor?dis=50) from their own taps. President John Dramani Mahama, in his 2025 State of the Nation Address, flagged that an estimated area of forest equivalent to [7,500 standard football fields](https://mlnr.gov.gh/wp-content/uploads/2025/07/WEEKLY_E-NEWSLETTER_FEB_24_20251.pdf) had now been destroyed by illegal miners; concrete proof that gold mining comes at an enormous ecological cost.',
  },
  s6P2: {
    id: 'rm_mine-my-phone-story01_s6_p2',
    defaultMessage:
      '“The pollution levels in major rivers within the Southwestern Basin are critically high, with turbidity levels far exceeding permissible limits,” he warned.',
  },
  s6P3: {
    id: 'rm_mine-my-phone-story01_s6_p3',
    defaultMessage:
      'Mr. Emmanuel Armah Kofi Buah, Minister for Lands and Natural Resources, described the contamination of water bodies as equally alarming, with rivers laced with toxic chemicals including cyanide, mercury, and hydrocarbons. Turbidity levels (how clear or cloudy water looks) in affected river systems have been recorded between 5,000 and 12,000 Nephelometric Turbidity Units (NTU). This is far above Ghana’s national standard of 500 Nephelometric Turbidity Units (NTU). Water with a turbidity above 500 NTU, the national limit, means you cannot see to the bottom of a glass of water because it is so heavily mixed with dirt and chemicals.',
  },
  s6P4: {
    id: 'rm_mine-my-phone-story01_s6_p4',
    defaultMessage:
      'The South-Western Basin, which feeds into the Pra, Offin, and Oda rivers, has been the hardest hit of Ghana’s three main basin systems. The damage extends well beyond water. In the Upper Denkyira East Municipality of Ghana’s Central Region, Mr. Paul Akwetey, a district agricultural extension officer, says agricultural supervision has ceased in five operational areas, comprising more than forty communities due to the intensity of mining activity.',
  },
  s6P5: {
    id: 'rm_mine-my-phone-story01_s6_p5',
    defaultMessage:
      'Production of staple crops like rice, cassava, plantain, maize, and vegetables are no longer being cultivated in these communities along the Offin River, as farmland has been sold off to miners. “Many have abandoned farming, and vast cropping land areas along the Offin River have been lost because they have been sold to miners to extract gold,” he said. Akwetey also expressed concern that food crops in affected areas likely contain mercury and cyanide, findings he believes would be confirmed if the Environmental Protection Authority’s recent nationwide study on toxic heavy metals in crops, water, soil, and fish were replicated in his district.',
  },
  s7Title: {
    id: 'rm_mine-my-phone-story01_s7_title',
    defaultMessage: 'A public health emergency in the making',
  },
  s7P1: {
    id: 'rm_mine-my-phone-story01_s7_p1',
    defaultMessage:
      'Ms. Sophia Stanger, Focal Point for Environmental Peacebuilding at the Austrian Centre for Peace (ACP), and someone who has spent considerable time visiting mining communities in Ghana, warned that the consequences of today’s mining practices will echo on for generations to come. “A part of the mercury washes into the soil and water bodies, while other parts evaporate into the air. Mercury is highly harmful to ecosystems and people, causing kidney disease, damage to the nervous system, and deformities in unborn children,” she explained.',
  },
  s8P1: {
    id: 'rm_mine-my-phone-story01_s8_p1',
    defaultMessage:
      'She also expressed concern that areas affected by artisanal mining are rarely restored. “The soil remains exposed and continues to degrade. Toxic chemicals become irreversibly embedded in soil and water, polluting food and water systems in the process.”',
  },
  s8P2: {
    id: 'rm_mine-my-phone-story01_s8_p2',
    defaultMessage:
      'Beyond these environmental issues, Ms. Stanger pointed to deepening social fractures in mining communities. This includes tension over rising prices, increased gender-based violence, higher rates of teenage pregnancy, land conflicts, and growing tensions between pro- and anti-mining factions.',
  },
  s8P3: {
    id: 'rm_mine-my-phone-story01_s8_p3',
    defaultMessage:
      '“Once mining zones are exhausted, people move on. But those left behind, who depend on the land for farming and on healthy water bodies for drinking, bear the consequences. Mercury and other chemicals cannot be filtered out of water. They remain. So what might Ghana look like in a few decades? What land are we leaving for the children of today and those of tomorrow?” she asked.',
  },
  s8P4: {
    id: 'rm_mine-my-phone-story01_s8_p4',
    defaultMessage:
      'The Pediatric Society of Ghana has sounded the alarm in even starker terms, calling on Ghana’s Presidency and Legislature to treat the threat illegal gold mining poses to children’s health as a “national emergency.” In an [open letter](https://pedsgh.com/2026/02/24/psgs-open-letter-to-the-president-on-galamsey/), the Society called for immediate action, including heavy metal screening in high-risk areas and protection of all water sources.',
  },
  s8P5: {
    id: 'rm_mine-my-phone-story01_s8_p5',
    defaultMessage:
      'Dr. Hilda Mantebea Boye, President of the Society, warned that pregnant women and young children are being exposed through contaminated drinking water, fish, crops, and household dust. “These toxins easily cross the placenta and enter breast milk, affecting children during their most critical developmental stages, causing permanent brain damage, reduced IQ and learning capacity, speech delays, behavioural disorders, and kidney and liver damage,” she said.',
  },
  s8P6: {
    id: 'rm_mine-my-phone-story01_s8_p6',
    defaultMessage:
      'The consequences for Ghana’s future are profound. “Small-scale mining, especially the illegal type, creates a destructive cycle: it damages the environment, undermines health and productivity, and weakens Ghana’s capacity to manage resources responsibly,” Dr. Boye added. Boye would like to see more awareness among Western consumers of these realities.',
  },
  s9Title: {
    id: 'rm_mine-my-phone-story01_s9_title',
    defaultMessage: 'Government response',
  },
  s9P1: {
    id: 'rm_mine-my-phone-story01_s9_p1',
    defaultMessage:
      'Mr. Felix Kwakye Ofosu, Minister of State in charge of Government Communications, said the current administration has moved swiftly since taking office.',
  },
  s9P2: {
    id: 'rm_mine-my-phone-story01_s9_p2',
    defaultMessage:
      'Measures implemented include a ban on mining in forest reserves, the establishment of the Ghana Gold Board (GoldBod) to better organise and oversee the small-scale sector, the launch of the Blue Water Initiative to protect water bodies, and strict permitting requirements for importing heavy mining equipment.',
  },
  s10P1: {
    id: 'rm_mine-my-phone-story01_s10_p1',
    defaultMessage:
      'Ongoing initiatives include afforestation programmes, decentralisation of mining licences to improve community involvement and transparency, and the constitution of the National  Anti-Illegal Mining Operations Secretariat, which is a dedicated task force to combat illegal small-scale mining.',
  },
  s11Title: {
    id: 'rm_mine-my-phone-story01_s11_title',
    defaultMessage: 'Environmentalist doubts',
  },
  s11P1: {
    id: 'rm_mine-my-phone-story01_s11_p1',
    defaultMessage:
      'For environmental advocates, the government’s measures, however well-intentioned, do not yet match the full scale of the crisis. Mr Daryl Bosu, Deputy National Director of A Rocha Ghana, said Ghana has fundamentally failed to implement integrated land use planning that separates mining zones from farmlands, forests, and water catchment areas. While gold revenues bolster foreign exchange reserves at a macro level, communities where mining actually takes place remain impoverished, jobless, and dispossessed.',
  },
  s11P2: {
    id: 'rm_mine-my-phone-story01_s11_p2',
    defaultMessage:
      '“The indicator for a well-governed mineral sector is how the land, rivers, and forests where minerals are extracted are also taken care of and replenished. If you don’t see that, we cannot use macroeconomic indicators as a sign that we are doing better,” he insisted.',
  },
  s11P3: {
    id: 'rm_mine-my-phone-story01_s11_p3',
    defaultMessage:
      'Dr. Emmanuel Steve Asare Manteaw has called for an urgent, comprehensive assessment of Ghana’s gold miners, comparing the financial benefits of increased gold production against the full environmental and social costs; costs that have fallen disproportionately on the most vulnerable communities.',
  },
  s11P4: {
    id: 'rm_mine-my-phone-story01_s11_p4',
    defaultMessage:
      'He said the [World Bank](https://documents.worldbank.org/en/publication/documents-reports/documentdetail/922571641829781399) funded Ghana Land Restoration and Small-Scale Mining Project, currently rated as “[moderately unsatisfactory](https://documents1.worldbank.org/curated/en/099062626194023254/pdf/P171933-4dc510a4-f35c-4590-9b7f-16cb654fb5ae.pdf)”,  must achieve its objective of strengthening integrated natural resource management and also increasing benefits to communities in targeted savannah and cocoa forest landscapes.',
  },
  s11P5: {
    id: 'rm_mine-my-phone-story01_s11_p5',
    defaultMessage:
      'Ms. Stanger goes one step further, arguing that the kind of gold mining practised today, including the use of toxic chemicals near water bodies, must stop immediately. She aligns with Ghanaian scientists and environmentalists, who accept that some forms of mining may continue, but not near rivers, and not in the manner the small-scale sector currently operates.',
  },
  s12P1: {
    id: 'rm_mine-my-phone-story01_s12_p1',
    defaultMessage:
      'She also turns her gaze to the international community: “The global appetite for gold is ultimately what drives prices and provides the main incentive for mining. Curbing that appetite is part of the solution.”',
  },
  s13Title: {
    id: 'rm_mine-my-phone-story01_s13_title',
    defaultMessage: 'Who pays the real price?',
  },
  s13P1: {
    id: 'rm_mine-my-phone-story01_s13_p1',
    defaultMessage:
      'The gold in your smartphone almost certainly passed through hands like Yaw’s and Kweku’s ; men working in conditions that few consumers in New York, London, Tokyo, or Berlin rarely pause to imagine. Ghana’s small-scale miners are producing gold at a pace that dwarfs global smartphone demand, generating billions for the national economy and stabilising a currency under pressure, Mr Bosu argued further.',
  },
  s13P2: {
    id: 'rm_mine-my-phone-story01_s13_p2',
    defaultMessage:
      'But the rivers are brown. The forests are gone. The children are absorbing mercury into their bloodstream. And the farmland that fed generations has been swallowed by open pits that nobody will fill.',
  },
  s13P3: {
    id: 'rm_mine-my-phone-story01_s13_p3',
    defaultMessage:
      'The world’s insatiable demand for gold to build its phones, its computers, its jewellery, and its investment portfolios, has a geography. It has a face. And increasingly, it comes with a cost that Ghana alone is being asked to bear.',
  },
  f1P1: {
    id: 'rm_mine-my-phone-story01_f1_p1',
    defaultMessage:
      'A silted part of the Birim River due to illegal mining in Akyem Adurom, the Eastern Region of Ghana. Credit: Albert Oppong-Ansah',
  },
  f2P1: {
    id: 'rm_mine-my-phone-story01_f2_p1',
    defaultMessage:
      'An Illegal mining site at Akyem Adukrom, the Eastern Region of Ghana. Credit: Albert Oppong-Ansah',
  },
  f3P1: {
    id: 'rm_mine-my-phone-story01_f3_p1',
    defaultMessage:
      'Work going on at an illegal mining site at Akyem Adukrom, Eastern Region of Ghana. Credit: Albert Oppong-Ansah',
  },
  f4P1: {
    id: 'rm_mine-my-phone-story01_f4_p1',
    defaultMessage:
      'Another polluted part of the Birim River. Credit: Albert Oppong-Ansah.',
  },
  f5P1: {
    id: 'rm_mine-my-phone-story01_f5_p1',
    defaultMessage:
      'Birim River at Anyinam, Ghana. Credit: Albert Oppong-Ansah.',
  },
  q1: {
    id: 'rm_mine-my-phone-story01_q1',
    defaultMessage:
      '“The toxins from gold extraction are released into rivers and crops. Subsequently, they easily cross the placenta and enter breast milk, affecting children during their most critical developmental stages.”',
  },
  q1Attr: {
    id: 'rm_mine-my-phone-story01_q1_attr',
    defaultMessage:
      'Dr. Hilda Mantebea Boye, president of the Pediatric Society of Ghana',
  },
  q2: {
    id: 'rm_mine-my-phone-story01_q2',
    defaultMessage:
      '“Gold is prized not only for jewellery and investment, but also because it is one of the world’s best electrical conductors. Fast Tech relies on it.”',
  },
  q2Attr: {
    id: 'rm_mine-my-phone-story01_q2_attr',
    defaultMessage: 'Mr. Samuel Boateng, a technology consultant',
  },
} as const
